import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

type State = { failed: boolean }

export default class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Errore di rendering dell’applicazione', error, info)
  }

  render() {
    if (!this.state.failed) return this.props.children

    return <main className="auth-screen">
      <section className="auth-card app-crash-card" role="alert">
        <div className="auth-mark crash-mark"><AlertTriangle size={24} aria-hidden="true" /></div>
        <span className="eyebrow">Vista interrotta</span>
        <h1>Non riesco a mostrare questa pagina</h1>
        <p>I dati non sono stati modificati. Ricarica l’applicazione per ricostruire la vista e riprovare.</p>
        <div className="modal-actions">
          <a className="button" href="/">Torna alla panoramica</a>
          <button type="button" className="button primary" onClick={() => window.location.reload()}>
            <RefreshCw size={15} aria-hidden="true" />Ricarica
          </button>
        </div>
      </section>
    </main>
  }
}
